import { useQuery } from '@tanstack/react-query';
import { ApiClient } from 'lib/api/client';
import { QUERY_KEYS } from 'settings/config';
import { useApiReady } from './use-api-ready';

/** Get the current user */
export function useUser() {
  const enabled = useApiReady();

  return useQuery(
    [QUERY_KEYS.user],
    () => new ApiClient().userApi.userRetrieve(),
    {
      select: (data) => data.data,
      enabled,
    }
  );
}
